var JobMatchAction = /** @class */ (function () {
    function JobMatchAction(action, actionType, allowed, message) {
        this.action = action;
        this.actionType = actionType;
        this.allowed = allowed;
        this.message = message;
    }
    return JobMatchAction;
}());
export { JobMatchAction };
//# sourceMappingURL=jobMatchAction.js.map